// Represents the test web app that uses the AppAuthJS library.
// Copied and adapted from  https://github.com/openid/AppAuth-JS/blob/master/src/app/index.ts
// https://authts.github.io/oidc-client-ts/
//
/* package.json
    "oidc-client-ts": "~3.0.0-beta.10",
*/
import { UserManager } from 'oidc-client-ts'

import os from 'os'

/* Some interface declarations for Material design lite. */

/* an example open id connect provider */
const openIdConnectUrl = 'https://auth.dataporten.no'
const clientId = '4abebba0-18cf-4da8-89f7-0d3ad416826e'
let feideClientId = ''

// const clientSecret = 'a2d5fb15-a0fb-4538-a5ad-cc1751a53c80'
const scope =
  'userid userinfo-name groups-edu groups-org openid longterm userid-feide id_token token refresh_token userinfo-photo'

// 'userid profile groups-edu groups-org openid longterm userid-feide id_token token refresh_token userinfo-photo'

let redirectUri = ''
let silent_redirectUri = ''
if (os.hostname() === 'skolestart.localhost') {
  redirectUri = 'http://skolestart.localhost:8301/feidecallback'
  silent_redirectUri = 'http://skolestart.localhost:8301/silentCallback'
  feideClientId = clientId
}
if (os.hostname() === 'skolestart.learning-hub.no') {
  redirectUri = 'https://skolestart.learning-hub.no/feidecallback'
  silent_redirectUri = 'https://skolestart.learning-hub.no/silentCallback'
  feideClientId = clientId
}

console.log(
  '====================== GET OS FEIDE AUTH HOSTNAME : (%s)',
  os.hostname()
)
console.log(
  '====================== GET  FEIDE AUTH REDIRECT URI  : (%s)',
  redirectUri
)

/*
oauth.Client = {
  client_id: '2855357a-6f92-4f27-908e-cefb276a7997',
  client_secret:'0d1fa311-332e-42cb-92be-47df438181af',
  token_endpoint_auth_method: 'client_secret_basic',
}
*/
export class FeideAppAuth {
  as = null
  code_verifier = null
  code_challenge = null
  authorizationUrl = null
  code_challenge_method = 'S256'
  current_url = null
  client = {}

  code = ''
  state = ''
  userManager = null

  oidcSettings = {
    authority: openIdConnectUrl,
    client_id: feideClientId,
    // client_secret: clientSecret,
    redirect_uri: redirectUri,
    silent_redirect_uri: redirectUri, //silent_redirectUri,
    //      post_logout_redirect_uri: `${os.hostname()}`,
    post_logout_redirect_uri: `${redirectUri}`,
    response_type: 'code',
    scope: scope
  }

  constructor() {
    console.log('AppAuth constructor got called !')
    console.log(this.oidcSettings)
    this.userManager = new UserManager(this.oidcSettings)
  }

  setCodeStatus(code, state) {
    console.log('setCodeStatus got called:')
    console.log('state: ')
    console.log(state)
    this.code = code
    console.log('code: ')
    console.log(this.code)
    this.state = state
  }

  fetchServiceConfiguration() {
    return new Promise((resolve, reject) => {
      console.log('fetchServiceConfiguration got called !')
      resolve('OK')
    }) // promise
  }

  fetchServiceConfigurationToken(code, state) {
    console.log('fetchServiceConfigurationToken got called !')
    console.log(this.userManager)
    /*
    console.log('code:')
    console.log(code)
    console.log('state:')
    console.log(state)
    */
    return new Promise((resolve) => {
      if (this.userManager) {
        this.userManager.signinCallback().then((res) => {
          console.log('====== signinRedirectCallback returned ... (%j)', res)
          if (res) {
            resolve({
              success: true,
              accessToken: res.access_token,
              expiresIn: res.expires_at,
              idToken: res.id_token
            })
          } else {
            resolve({})
          }
        })
      } else {
        resolve({ success: false, error: true, errorMsg: 'No USER MANAGER' })
      }
    })
  }

  makeAuthorizationRequest() {
    console.log('====== makeAuthorizationRequest got called ...')
    return new Promise((resolve) => {
      // create a request
      if (this.userManager) {
        this.userManager
          .signinRedirect()
          .then((res) => {
            console.log('====== signinRedirectCallback got called ...')
            resolve('ok')
          })
          .catch((err) => {
            console.log('***ERROR*** signinRedirectCallback got called ...')
            console.log(err)
            resolve('error')
          })
      } else {
        resolve('noUserManager')
      }
    }) // promise
  }

  makeRefreshTokenRequest(code) {
    console.log('========= makeRefreshTokenRequest got called ! (' + code + ')')
    return new Promise((resolve) => {
      resolve('ok')
    }) // promise
  }

  makeTokenRequest(code) {
    return new Promise((resolve, reject) => {
      console.log(
        '========= MakeTokenRequest(code) got called ! code:(' + code + ')'
      )
      resolve('ok')
    }) // promise
  }

  loggedIn() {
    return !!this.accessTokenResponse && this.accessTokenResponse.isValid()
  }

  async signOut() {
    // forget all cached token state
    await this.userManager.signoutSilent()
    this.code = null
    this.state = null
    this.accessTokenResponse = undefined
    this.userManager = null
    /*   this.userManager.signOutRedirect({redirectMethod:'replace', redirectTarget: 'self'})
      .then(res => {
        console.log('====== signOutSilent got called ...')
        console.log(res)
      })
      */
  }

  checkForAuthorizationResponse() {
    return new Promise((resolve) => {
      console.log('checkForAuthorizationResponse got called !!')

      resolve('ok')
    }) // promise
  }

  silentSigning() {
    console.log('SILENT SIGNIN GOT CALLED ...')
    console.log(this.userManager)
    return new Promise((resolve, reject) => {
      this.userManager
        .signinSilent()
        .then((res) => {
          console.log('====== silentSigningin got called ...')
          console.log(res)
          resolve(res)
        })
        .catch((err) => {
          console.info(
            '***ERROR*** silentSigningin failed - must login ...',
            err.toString()
          )
          reject(err)
        })
    }) // promise
  }
}
